import { render, staticRenderFns } from "./BackToBandlab.vue?vue&type=template&id=8dd1a8cc&"
import script from "./BackToBandlab.vue?vue&type=script&lang=ts&"
export * from "./BackToBandlab.vue?vue&type=script&lang=ts&"
import style0 from "./BackToBandlab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports